// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3Ofgy","footer":"ReportModalFilter_footer__1aot_"};